<template>
  <div>
    <h1>Gestion des conducteurs </h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
        >


        <template slot="actions" slot-scope="props">

          <va-popover placement="bottom" title="Détails">
            <va-button @click="showDriverDetail(props.rowData)" flat small color="gray" icon="fa fa-eye" />
          </va-popover>

          <va-button v-if="props.rowData.is_approved == false" @click="postApprouve(props.rowData, true)">Approuver</va-button>
          <va-button color="danger" class="" v-if="props.rowData.is_approved == true" @click="postApprouve(props.rowData, false)">Désapprouver</va-button>
        
        </template>


      </va-data-table>
    </va-card>

      <!-- modal showDriverModal -->
    <va-modal size="large" v-model="showDriverModal" title="Conducteur">

      <div class="row" v-if="driverInfo">

          <div class="flex xs7"> 

            <div v-if="driverInfo.info">

              <div class="item">
                <h6>Photo de profil</h6> 
                <p><img  :src="driverInfo.info.photo" alt="" id="profil"></p>
              </div>

              <div class="item">
                <h6>Permis avant</h6> 
                <p><a class="zoom" :href="driverInfo.info.driver_driving_licence_front" target="_blank"><img :src="driverInfo.info.driver_driving_licence_front" alt="" class="item_img"></a></p>
              </div>
              <div class="item">
                <h6>Permis arrière</h6> 
                <p><a class="zoom" :href="driverInfo.info.driver_driving_licence_back" target="_blank"><img :src="driverInfo.info.driver_driving_licence_back" alt="" class="item_img"></a></p>
              </div>
            </div>

          
          <div v-if="driverInfo.default_car">

              <div class="item">
                <h6>carte grise</h6> 
                <p><a class="zoom" :href="driverInfo.default_car.car_card" target="_blank"><img :src="driverInfo.default_car.car_card" alt="" class="item_img"></a></p>
              </div>

            </div>


          </div>

          <div class="flex xs5">


            <div v-if="driverInfo">

              <div class="item">
                <h6>Nom complet</h6> 
                <p>{{driverInfo.full_name}}</p>
              </div> 

              <div class="item">
                <h6>Genre</h6> 
                <p>{{driverInfo.gender}}</p>
              </div> 

              <div class="item">
                <h6>Date de création</h6> 
                <p>{{dataMoment(driverInfo.created_date)}}</p>
              </div>

              <div class="item">
                <h6>Date de désactivation</h6> 
                <p>{{dataMoment(driverInfo.disable_datetime)}}</p>
              </div>

              <div class="item">
                <h6>Date d'approbation</h6> 
                <p>{{dataMoment(driverInfo.approval_datetime)}}</p>
              </div> 

            </div>


            <div v-if="driverInfo">

              <div class="item">
                <h6>Pays</h6> 
                <p>{{driverInfo.country}}</p>
              </div> 

              <div class="item">
                <h6>Ville</h6> 
                <p>{{driverInfo.city}}</p>
              </div> 

            </div>


            <div v-if="driverInfo.info">

              <div class="item">
                <h6>Numéro de permis</h6> 
                <p>{{driverInfo.info.driver_driving_licence_id}}</p>
              </div>

            </div>

          
          </div>
      </div>
    </va-modal> 


  </div>

</template>

<script>
import moment from 'moment'

import { debounce } from 'lodash'
import service from "../../providers/service";

export default {
  data () {
    return {
      driver:[],
      showDriverModal: false,
      term: null,
      data : [],
      driverInfo : null,
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'full_name',
          title: 'Nom complet',
          sortField: 'full_name'
        }, 
        {
          name: 'info.id_type',
          title: 'Type de piece',
          sortField: '[info][id_type]'
        },
        {
          name: 'info.driver_driving_licence_id',
          title: 'Numero d\'identité',
          sortField: 'info.driver_driving_licence_id',
        },   
        {
          name: 'info.id_number',
          title: "Numéro de piece",
          sortField: 'info.id_number'
        }, 
        {
          name: 'is_disable',
          title: "Desactiver",
          sortField: 'is_disable'
        }, 
        {
          name: 'gender',
          title: "Genre",
          sortField: 'gender'
        }, 
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.full_name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {

    	dataMoment: function(created_date) {
        return moment(created_date).format('DD/MM/YYYY');
      
      },

    search: debounce(function (term) {
      this.term = term
    }, 400),

    showDriverDetail(driver){
      console.log(driver);
      this.driverInfo = driver;
      this.showDriverModal = true;
    },

    getListDriver(){

      service.getDrivers(localStorage.userAccesstoken).then( res => {
      console.log(res);
      if(res.status === 200){

        this.data = res.data;
      }
    })

    },

    postApprouve:function(data, value) {
      console.log(data);
      service.postApprouvDriver(data.id, value, localStorage.userAccesstoken)
      .then(res=> {
        if (res.status==200) {
          
          if(value == true){
            alert('Conducteur approuvé')
          }else{
            alert('Conducteur desapprouvé')
          }

          this.getListDriver();
        
      }})
    }

  },
  
  mounted(){
    this.getListDriver();
  }
}
</script>

<style lang="scss">
  #profil{
    width: 7em;
    height: 7em;
    border-radius: 5em !important;
  }

  .item{
    margin: 1em;
    background-color: #e4e7f5;
    padding: 1em;
  }

  .zoom{
    cursor:zoom-in;
  }

  .item_img{
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

</style>